import { Alert, Snackbar, Typography } from "@mui/material";
import { styles } from "../../style/style";


export default function ErrorSnackbarNotification(props) {
    const { errorMessage, open, handleClose, errorType } = props;
    //console.log(errorMessage)

    return (
        <>
            {errorMessage !== "" &&
                <Snackbar sx={styles.snackbars} open={open} onClose={handleClose}
                    autoHideDuration={6000}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                >
                    <Alert id="errorAlert" severity={errorType} onClose={handleClose}>
                        <Typography sx={{ width: '100%' }}>{errorMessage}</Typography>
                    </Alert>
                </Snackbar>
            }
        </>
    )
}


/* export default function ErrorSnackbarNotification(props) {
    const { errorMessage, open, handleClose, errorType } = props;

    const errorId = errorMessage.toString().toUpperCase().replace(/ /g,"_");
    console.log(errorId)

    return (
        <>
            {errorMessage !== "" &&
                <Snackbar sx={styles.snackbars} open={open} onClose={handleClose}
                    autoHideDuration={6000}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                >
                    <Alert severity={errorType} onClose={handleClose}>
                        <Typography sx={{ width: '100%' }}>

                            <FormattedMessage
                                id={errorId}
                                values={{ errorMessage: errorMessage }}
                                defaultMessage='Error Found' />


                        </Typography>
                    </Alert>
                </Snackbar>
            }
        </>
    )
} */